import { createContext, useContext, useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  website_name: "Mashiniya",
  tagline: "New Machines • Used Machines • Spare Parts",
  parent_company: "Indra Sphere",
  phone1: "+91 78971 94942",
  phone2: "+91 91942 28844",
  email: "contact@mashiniya.com",
  address: "Kidwai Nagar, Pukhrayan, Kanpur Dehat, Uttar Pradesh – 209111, India",
  seo_title: "Mashiniya — New & Used Machines and Spare Parts | Indra Sphere",
  seo_description: "Explore new machines, used machines, second-hand equipment and machine spare parts on Mashiniya.",
  footer_text: "Mashiniya is a platform for discovering and connecting buyers and sellers of new machines, used machines and machine spare parts.",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings({ ...DEFAULTS, ...r.data })).catch(() => {});
  }, []);

  useEffect(() => {
    if (settings.favicon_url) {
      let link = document.querySelector('link[rel="icon"]') || (() => {
        const l = document.createElement("link"); l.rel = "icon"; document.head.appendChild(l); return l;
      })();
      link.href = fileUrl(settings.favicon_url);
    }
  }, [settings.favicon_url]);

  return <SettingsContext.Provider value={{ settings, setSettings }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext) || { settings: DEFAULTS, setSettings: () => {} };
